import { COMPLETED_PROJECTS } from '@/data/company'

/** 외주 진행 절차와 계약 안내 문구. 자주 바뀌지 않아 DB 가 아니라 코드 상수로 둬요. */

export interface ProcessStep {
  title: string
  body: string
  /** 이 단계 아래에 계약서 요약 카드를 붙여요. */
  showContract?: boolean
}

export interface ContractTerm {
  label: string
  body: string
}

export const PROCESS_STEPS: ProcessStep[] = [
  {
    title: '견적 문의 접수',
    body: '온라인 견적을 남겨주시면 24시간 이내에 연락드려요. 어떤 걸 만들고 싶은지, 어디까지 필요한지 먼저 들어요.',
  },
  {
    title: '요구사항 명세서 확정',
    body: '들은 내용을 요구사항 명세서로 정리해 보내드려요. 고객사가 확인하고 확정한 이 문서가 이후 개발 범위의 기준이 돼요.',
  },
  {
    title: '견적 확정 및 계약',
    body: '확정된 명세서로 최종 견적을 내고 계약해요. 계약금은 견적가의 10%예요.',
    showContract: true,
  },
  {
    title: '1차 프로토타입 전달',
    body: '먼저 동작하는 1차 프로토타입을 만들어 드려요. 결과가 마음에 들지 않으면 계약 후 30일 이내에 계약금을 환불해 드려요.',
  },
  {
    title: '구현 완료·검수·잔금',
    body: '남은 기능까지 구현해 최종 검수를 받아요. 검수가 끝나면 잔금을 받고 소스코드와 권리를 넘겨드려요.',
  },
]

/** 계약서 조항 전문 대신 싣는 요약. 실제 계약서는 docs/contract-template.md 가 원본이에요. */
export const CONTRACT_SUMMARY: ContractTerm[] = [
  { label: '용역 범위', body: '확정된 요구사항 명세서 기준이에요. 명세서에 없는 신규 요구는 별도로 협의하고 정산해요.' },
  { label: '대금', body: '계약금은 견적가의 10%, 잔금은 최종 검수 후에 받아요. 부가세는 별도예요.' },
  {
    label: '환불',
    body: '1차 프로토타입이 마음에 들지 않으면 계약 후 30일 이내에 계약금을 전액 환불해 드리고, 그때까지 진행된 작업도 따로 청구하지 않아요.',
  },
  {
    label: '산출물·권리',
    body: '검수 완료 후 잔금을 완납하시면 프론트엔드·백엔드 전체 소스, 빌드·배포 구성, 데이터 모델 정의와 지식재산권을 인도해 드려요.',
  },
  { label: '납품·검수', body: '검수 서버와 운영 서버에 배포하고, 고객사 검수가 끝나면 개발 완료로 봐요.' },
  { label: '하자보수', body: '명세서 범위 안에서 생긴 결함은 무상으로 고쳐요. 기간은 계약할 때 함께 정해요.' },
  {
    label: '인프라',
    body: '클라우드·도메인 비용은 별도 합의 전까지 저희가 부담하고, 필요하면 고객사 명의로 이관해 드려요.',
  },
  { label: '비밀유지·해지', body: '계약이 끝난 뒤에도 2년간 비밀을 지켜요. 해지하면 그때까지 진행된 만큼 정산해요.' },
]

/**
 * 견적 패널의 대금 안심 카드. 문의를 누르기 직전의 부담을 줄이는 게 목적이라
 * "먼저 받아보고 나중에 낸다" 순서 그대로 세 칸에 나눠 담아요.
 *
 * 새 약속이 아니라 계약서에 이미 있는 조건이에요. 문장마다 근거가 있어요 —
 * 1번은 제5조(계약금 10%), 2번은 제7조 ②(30일 내 계약금 전액 환불)·③(기성고 별도 청구 안 함),
 * 3번은 제8조 ②(결함 보완 후 재검수)·제5조(잔금은 검수 완료 후).
 *
 * **"마음에 안 들면 돈을 안 받는다" 가 성립하는 건 프로토타입 단계뿐이에요.** 최종 검수는
 * 제8조상 "기능명세서에 부합하는가" 판정이지 주관적 만족도가 아니라서, 3번을 "마음에 안 들면
 * 잔금을 안 받아요" 로 고치면 제5·8조와 어긋나는 새 약속이 돼요. 그렇게 쓰려면 문구가 아니라
 * 계약서 제8조를 먼저 고쳐야 해요. 아래 CONTRACT_SUMMARY 의 '대금'·'환불' 항목과도 같은 말이어야 하고요.
 */
export const PAYMENT_STEPS: ProcessStep[] = [
  { title: '계약금 10%만', body: '착수할 때는 견적가의 10%만 입금하시면 돼요.' },
  {
    title: '마음에 안 들면 전액 환불',
    body: '동작하는 1차 결과물을 먼저 받아보세요. 마음에 들지 않으면 30일 이내에 계약금을 전액 돌려드리고, 그때까지 진행된 작업도 따로 청구하지 않아요.',
  },
  {
    title: '되기 전엔 잔금을 안 받아요',
    body: '약속한 기능이 다 동작할 때까지 고쳐드려요. 검수가 끝난 뒤에 잔금 90%를 받아요.',
  },
]

/** 견적 결과 패널의 '받으시는 것'. 환불 보장은 패널에 이미 박스로 있어 넣지 않아요. */
export const DELIVERABLES: string[] = [
  '검수 완료 후 잔금을 완납하시면 소스코드 일체와 지식재산권을 인도해 드려요',
  '.com 도메인 발급·연동까지 해드리고, 도메인·클라우드 비용은 별도 합의 전까지 저희가 부담해요',
]

/**
 * 히어로 CTA 아래 한 줄로 세우는 "받으시는 것" 배지. 첫 화면에서는 스캔되게 짧게만 두고,
 * 조건(잔금 완납 시점·환불 기간)은 견적 패널의 DELIVERABLES 와 진행 절차 다이얼로그가 받아요.
 */
export const HERO_BADGES: string[] = [
  `배포·운영까지 마친 프로젝트 ${COMPLETED_PROJECTS}개+`,
  '소스코드·지식재산권 인도',
  '.com 도메인 발급·연동',
  '계약금 환불 보장',
]
